import { useQuery } from "@tanstack/react-query";
import { orderService } from "@/services/orderService";

export function useOrderBook() {
  return useQuery({ queryKey: ["orders", "book"], queryFn: orderService.getOrderBook });
}
